'use client'

import {
  Flex,
  Grid,
  GridItem,
  Skeleton,
  Spinner,
  VStack,
} from '@chakra-ui/react'
import {
  useGetDonorDetailQuery,
  useGetDonorCardDetailQuery,
} from '@entities/donor/api/get-donor.api'
import {
  DonorDeferralHistoryCard,
  DonorDonationHistoryCard,
  DonorStatusCard,
  PatientStatusCard,
} from '@/widgets'

interface Props {
  visitId: string
  /** Lifting a deferral is the registrar/therapist side's action. */
  canOverrideDeferral?: boolean
}

export function GeneralTab({ visitId, canOverrideDeferral = false }: Props) {
  const { data: donorDetail, isPending: donorDetailIsPending } =
    useGetDonorDetailQuery(visitId)

  const { data: donor, isPending: donorPending } = useGetDonorCardDetailQuery(
    donorDetail?.donor_id ?? '',
  )

  if (donorDetailIsPending || donorPending) {
    return (
      <Flex justify="center" align="center" minH="200px">
        <Spinner size="lg" color="primary.fg" />
      </Flex>
    )
  }

  if (!donor) return null

  return (
    <VStack gap={5} align="stretch">
      <DonorDonationHistoryCard donations={donor.donation_history} />

      {donorDetail && (
        <DonorDeferralHistoryCard
          donorId={donorDetail.donor_id}
          donorName={donorDetail.full_name}
          canOverride={canOverrideDeferral}
        />
      )}

      <Grid templateColumns={{ base: '1fr', md: 'repeat(3, 1fr)' }} gap={5}>
        <GridItem>
          <DonorStatusCard donor={donor} />
        </GridItem>
        {/* {donor.patientStatusBlue && (
          <GridItem>
            <PatientStatusCard text={donor.patientStatusBlue} variant="blue" />
          </GridItem>
        )}
        {donor.patientStatusYellow && (
          <GridItem>
            <PatientStatusCard
              text={donor.patientStatusYellow}
              variant="yellow"
            />
          </GridItem>
        )} */}
      </Grid>
    </VStack>
  )
}
